"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = ({ children, className }) => {
    return (0, jsx_runtime_1.jsx)(Container, { className: className, children: children }, void 0);
};
const Container = styled_components_1.default.div `
  & > div:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }
`;
//# sourceMappingURL=ListWithMargin.js.map